module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-152x152.4a1c0740ba22e5e34c56acffdaf3e78b.png";